module.exports = __webpack_public_path__ + "static/media/drinking_water.b2bbb758.jpg";